module.exports = __webpack_public_path__ + "static/media/battery-car.7213f6c5.svg";